document.addEventListener('DOMContentLoaded', function() {
  const filterToggle = document.querySelector('.filter-toggle');
  const filterContent = document.querySelector('.filter-content');
  const productGridContainer = document.querySelector('.product-grid-container');

  filterToggle.addEventListener('click', function() {
    const isExpanded = filterToggle.getAttribute('aria-expanded') === 'true';
    filterToggle.setAttribute('aria-expanded', !isExpanded);
    filterContent.setAttribute('aria-hidden', isExpanded);

    if (!isExpanded) {
      filterContent.style.display = 'block';
      productGridContainer.style.paddingLeft = '35rem'; // Adjust this value as needed
    } else {
      filterContent.style.display = 'none';
      productGridContainer.style.paddingLeft = '5rem';
    }
  });
});
